import { Link } from '@tanstack/react-router';

import { cx } from '@libs/classnames';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { CertificateSealIcon } from '@ui/icons/CertificateSealIcon';

import styles from './TournamentPromoBadge.module.css';

export function TournamentPromoBadge({
  title,
  link,
  className,
}: {
  className?: string;
  title?: string | null;
  link?: string | null;
}) {
  const isDesktop = useMediaQuery() === 'desktop';

  return (
    <div className={cx(styles.promoBadge, className)}>
      <CertificateSealIcon />
      {title ?? 'Турнир по подписке'}
      {link && (
        <Link to={link} className={styles.link} target="_blank" rel="noopener">
          {isDesktop ? 'Узнать больше ›' : '?'}
        </Link>
      )}
    </div>
  );
}
